/**
 * @created on 2018/1/8
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import { getRunTime } from '../../../public-resource/libs/utils/index'

let HOST = getRunTime('//m.xinli001.com')
let SHOST = getRunTime('//static.xinli001.com')
let YIAPI_HOST = getRunTime('//yiapi.xinli001.com')
let $ = function(name) {
  return document.querySelector(name)
}

let btnConfig = [
  {
    icon: 'back',
    position: 'left',
    callback() {
      window.history.back()
    }
  },
  {
    icon: 'share',
    position: 'right',
    callback() {}
  }
]
if (document.referrer === '') {
  btnConfig = [
    {
      tips: '回首页',
      position: 'left',
      style: 'color:#fff',
      callback() {
        window.location.href = api.IndexUrl
      }
    },
    {
      icon: 'share',
      position: 'right',
      callback() {}
    }
  ]
}
let $headerConfigLink = {
  personalLink: window.baseInfo.user_home_url,
  infoLink: window.baseInfo.message_url,
  searchLink: `${SHOST}/msite/index.html#/search`
}
console.log('---baseInfo---', window.baseInfo)
let api = {
  followTheme: `${HOST}/article/theme/follow-toggle.json`,
  readSign: `${HOST}/article/theme/article-read.json`,
  getWXShareConfig: `${HOST}/wx/get-wx-package.json`,
  advertise: `${YIAPI_HOST}/v5/yi/get-ad.json`
}
module.exports = {
  $el: {
    follow: $('.theme-content'),
    tabNav: $('.essence-nav'),
    essenceList: $('.essence-list')
  },
  api,
  headerConfig: {
    el: $('.container'),
    link: $headerConfigLink,
    messageNum: window.baseInfo.notice_total || 0
  }
}



// WEBPACK FOOTER //
// ./src/pages/fm/programShare/config.js